// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.jsdelivr.net/npm/keen-slider@5.5.1/+esm'

if (!customElements.get('close-mobile')) {
  customElements.define(
    'close-mobile',
    class ProductTechnologies extends window.BAO.CustomElement {
      constructor () {
        super()

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {

        if (this.els.slide.elements.length > 0) {
          this.els.slides.element.setAttribute(
            'data-custom-cursor-external-el',
            'carousel',
          )
        } else {
          return
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1.1,
          slides: '.car-Carousel_Slide',
          loop: false,
          spacing: 2,
          breakpoints: {
            '(min-width: 768px)': {
              centered: true,
              loop: true,
              mode: 'snap',
              slidesPerView: 1.1,
              spacing: 2
            }
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })
          },
        })
      }
    },
  )
}
